import { render, staticRenderFns } from "./fliter.vue?vue&type=template&id=a66969ac&scoped=true&"
import script from "./fliter.vue?vue&type=script&lang=js&"
export * from "./fliter.vue?vue&type=script&lang=js&"
import style0 from "./fliter.vue?vue&type=style&index=0&id=a66969ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66969ac",
  null
  
)

export default component.exports